export class GMMError extends Error {
  constructor(
    message: string,
    public status?: number,
    public code?: string,
  ) {
    super(message);
    this.name = "GMMError";
  }
}
export class APIError extends GMMError {}
export class AuthenticationError extends GMMError {}
export class RateLimitError extends GMMError {}
